import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/googleAnalytics";
import { trackMeta } from "../../utils/metaPixel";

export default function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    trackMeta("PageView");
  }, [location]);

  return null;
}
